var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
import { stringify } from 'qs';
// import JSONbig from 'json-bigint';
import JSONbig from '../json-bigint';
import BigNumber from 'bignumber.js';
import get from 'lodash/get';
import Service from '../request-pre';
import { formatMicroFrontUrl } from '../../init/router/microFrontUrl'; // 微前端路由方法
import cookie from '../cookie';
import { addConfigs } from './add.configs';
import { getFilenameFromContentDispositionHeader } from './tools';
import paramsSerializer from './paramsSerializer';
import { createMockServiceByData } from './mockData';
import { sseRequester } from './sseRequester';
import Config from '../../config';
import { overwriteErrorMsgFieldIfSpecified, isFormData, isArrayBuffer, isBuffer, isStream, isFile, isBlob, isArrayBufferView, isObject, } from './utils';
import { default as builtInInterceptors } from './interceptors';
const getData = (str) => new Function('return ' + str)();
function getJsonParse() {
    let hasSource = false;
    const jsonStr = `{"myBigInt":6028792033986383748 }`;
    JSON.parse(jsonStr, (...arg) => {
        if (get(arg, '2'))
            hasSource = true;
        return arg[1];
    });
    const warpJsonParse = (jsonStr) => JSON.parse(jsonStr, (...arg) => {
        if (typeof arg[1] === 'number' && Number.isInteger(arg[1]) && !Number.isSafeInteger(arg[1])) {
            return new BigNumber(get(arg, '2.source'));
        }
        return arg[1];
    });
    return hasSource ? warpJsonParse : JSONbig.parse;
}
const jsonParse = getJsonParse();
const formatContentType = function (contentType, data) {
    const map = {
        'application/x-www-form-urlencoded'(data) {
            return stringify(data);
        },
    };
    return map[contentType] ? map[contentType](data) : data;
};
const parseCookie = (str) => {
    if (typeof str !== 'string') {
        return {};
    }
    return str
        .split(';')
        .map((v) => v.split('='))
        .reduce((acc, v) => {
        const getValue = (s) => {
            try {
                return decodeURIComponent(s === null || s === void 0 ? void 0 : s.trim());
            }
            catch (error) {
                return s === null || s === void 0 ? void 0 : s.trim();
            }
        };
        // 有key才保留
        if (getValue(v[0])) {
            acc[getValue(v[0])] = getValue(v[1]);
        }
        return acc;
    }, {});
};
const formatCookie = (cookieStr) => {
    const result = {};
    if (document.cookie.length <= 0) {
        return result;
    }
    const obj = parseCookie(cookieStr);
    Object.keys(obj).forEach((key) => {
        result[key] = {
            name: key,
            value: obj[key],
            domain: '', // 前端只能拿到k v 其他字段补齐即可
            cookiePath: '',
            sameSite: '',
            httpOnly: '',
            secure: '',
            maxAge: '',
        };
    });
    return result;
};
/**
 * 目前主要测试的是 get 请求
 * 图片，文件，和文件流形式的下载
 * https://raw.githubusercontent.com/vusion/cloud-ui/master/src/assets/images/1.jpg
 * 支持 query 参数
 */
function download(url) {
    const { path, method, body = {}, headers = {}, query = {}, timeout } = url;
    return axios({
        url: formatMicroFrontUrl(path),
        method,
        params: query,
        data: formatContentType(headers['Content-Type'], body),
        responseType: 'blob',
        timeout,
    })
        .then((res) => {
        // 包含 content-disposition， 从中解析名字，不包含 content-disposition 的获取请求地址的后缀
        let effectiveFileName = res.request.getAllResponseHeaders().includes('content-disposition')
            ? getFilenameFromContentDispositionHeader(res.request.getResponseHeader('content-disposition'))
            : res.request.responseURL.split('/').pop();
        const { data, status, statusText } = res;
        // 通过UA判断是否是移动端
        const mobilePattern = /mobile|mobi|wap|simulator|iphone|android/gi;
        const isMobile = mobilePattern.test(navigator.userAgent);
        if (!isMobile) {
            effectiveFileName = decodeURIComponent(effectiveFileName).replace(/_\d{8,}\./, '.');
            if (data && data.size === 0) {
                return Promise.resolve({
                    data: {
                        code: status,
                        msg: statusText,
                    },
                });
            }
        }
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', effectiveFileName); // any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
        return Promise.resolve({
            data: {
                code: status,
                msg: statusText,
            },
        });
    })
        .catch((err) => 
    // 基于 AxiosError 的错误类型 https://github.com/axios/axios/blob/b7e954eba3911874575ed241ec2ec38ff8af21bb/index.d.ts#L85
    Promise.resolve({
        data: {
            code: err.code,
            msg: err.response.statusText,
        },
    }));
}
function formatCallConnectorPath(path, connectionName) {
    var _a;
    const sysPrefixPath = (_a = window.appInfo) === null || _a === void 0 ? void 0 : _a.sysPrefixPath;
    if (sysPrefixPath) {
        path = path === null || path === void 0 ? void 0 : path.replace(sysPrefixPath, '');
    }
    // /api/connectors/connector1/namespace1/getA
    const pathItemList = (path || '').split('/').filter((i) => i);
    if (pathItemList.length < 3) {
        throw Error('unexpected path when use CallConnector');
    }
    const [prefix1, prefix2, connectorName, ...rt] = pathItemList;
    return `${sysPrefixPath ? sysPrefixPath : ''}/${prefix1}/${prefix2}/${connectorName}/${connectionName}/${rt.join('/')}`;
}
export function genBaseOptions(requestInfo) {
    var _a, _b, _c, _d;
    const { url, config = {} } = requestInfo;
    const { method, body = {}, headers = {}, query = {} } = url;
    const path = formatMicroFrontUrl(url.path);
    const baseURL = config.baseURL ? config.baseURL : '';
    headers['Content-Type'] = headers['Content-Type'] || 'application/json';
    if (!headers.Authorization && cookie.get('authorization')) {
        headers.Authorization = cookie.get('authorization');
    }
    headers.DomainName = (_a = window.appInfo) === null || _a === void 0 ? void 0 : _a.domainName;
    if ((_b = window.appInfo) === null || _b === void 0 ? void 0 : _b.frontendName)
        headers['LCAP-FRONTEND'] = (_c = window.appInfo) === null || _c === void 0 ? void 0 : _c.frontendName;
    // 用户本地时区信息，传递给后端
    headers.TimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let data;
    const method2 = method.toUpperCase();
    if (Array.isArray(body) || Object.keys(body).length || ['PUT', 'POST', 'PATCH', 'DELETE'].includes(method2)) {
        data = formatContentType(headers['Content-Type'], body);
    }
    return {
        params: query,
        paramsSerializer,
        baseURL,
        method: method2,
        transformRequest: [
            function (data, headers) {
                try {
                    if (isFormData(data) ||
                        isArrayBuffer(data) ||
                        isBuffer(data) ||
                        isStream(data) ||
                        isFile(data) ||
                        isBlob(data)) {
                        return data;
                    }
                    if (isArrayBufferView(data)) {
                        return data.buffer;
                    }
                    if (isObject(data) || headers['Content-Type'].includes('application/json')) {
                        // 对于 JSON 请求，序列化的时候保持对象的形状，不让 undefined 字段消失。便于服务端识别
                        const replacerToKeepUndefinedFields = (_, value) => (value === undefined ? null : value);
                        const request = JSONbig.stringify(data, replacerToKeepUndefinedFields);
                        return request;
                    }
                    return data;
                }
                catch (error) {
                    return data;
                }
            },
        ],
        transformResponse: [
            function (data) {
                try {
                    const response = jsonParse(data);
                    return response;
                }
                catch (error) {
                    return data;
                }
            },
        ],
        url: path,
        data,
        headers,
        withCredentials: (_d = config.withCredentials) !== null && _d !== void 0 ? _d : !baseURL,
        xsrfCookieName: 'csrfToken',
        xsrfHeaderName: 'x-csrf-token',
        onUploadProgress: typeof config.onUploadProgress === 'function' ? config.onUploadProgress : () => { },
        onDownloadProgress: typeof config.onDownloadProgress === 'function' ? config.onDownloadProgress : () => { },
    };
}
const requester = function (requestInfo) {
    const { url, config = {} } = requestInfo;
    if (!(url === null || url === void 0 ? void 0 : url.path)) {
        throw Error('unexpected url path as', url === null || url === void 0 ? void 0 : url.path);
    }
    // 如果参数中存在 connectionName 则认为请求来自于 CallConnector
    const connectionName = config === null || config === void 0 ? void 0 : config.connectionName;
    if (connectionName && url) {
        url.path = formatCallConnectorPath(url.path, connectionName);
    }
    if (config.download) {
        return download(url);
    }
    if ((config === null || config === void 0 ? void 0 : config.serviceType) === 'sse') {
        return sseRequester(requestInfo);
    }
    const defaultErrorHandler = (error) => Promise.reject(error);
    // 内置拦截器
    builtInInterceptors.forEach((interceptor) => {
        const { request, response } = interceptor;
        if (request) {
            axios.interceptors.request.use(request.onSuccess, request.onError || defaultErrorHandler);
        }
        if (response) {
            axios.interceptors.response.use(response.onSuccess, response.onError || defaultErrorHandler);
        }
    });
    // 依赖库定义的响应拦截器
    if (window.$axiosHookManager) {
        const requestHooks = window.$axiosHookManager.requestHooks.sort((a, b) => (a === null || a === void 0 ? void 0 : a.order) - (b === null || b === void 0 ? void 0 : b.order));
        requestHooks.forEach((hook) => {
            if (hook && hook.onSuccess && !hook.registered) {
                axios.interceptors.request.use(hook.onSuccess, hook.onError || defaultErrorHandler);
                hook.registered = true;
            }
        });
        // 依赖库定义的响应拦截器
        const responseHooks = window.$axiosHookManager.responseHooks.sort((a, b) => (a === null || a === void 0 ? void 0 : a.order) - (b === null || b === void 0 ? void 0 : b.order));
        responseHooks.forEach((hook) => {
            if (hook && hook.onSuccess && !hook.registered) {
                axios.interceptors.response.use(hook.onSuccess, hook.onError || defaultErrorHandler);
                hook.registered = true;
            }
        });
    }
    const options = genBaseOptions(requestInfo);
    if (typeof window.axiosOptionsSetup === 'function') {
        window.axiosOptionsSetup(options);
    }
    // 自定义请求信息
    if (typeof Config.configureRequest === 'function') {
        Config.configureRequest(options, axios);
    }
    const req = axios(options);
    return req;
};
const service = new Service(requester);
// 调整请求路径
const adjustPathWithSysPrefixPath = (apiSchemaList) => {
    var _a, _b;
    const newApiSchemaMap = {};
    if (apiSchemaList) {
        for (const key in apiSchemaList) {
            if (!newApiSchemaMap[key]) {
                const _c = apiSchemaList[key] || {}, { url } = _c, others = __rest(_c, ["url"]);
                newApiSchemaMap[key] = Object.assign({ url: Object.assign({}, url) }, others);
            }
            const newApiSchema = newApiSchemaMap[key];
            const path = (_a = newApiSchema === null || newApiSchema === void 0 ? void 0 : newApiSchema.url) === null || _a === void 0 ? void 0 : _a.path;
            const sysPrefixPath = (_b = window.appInfo) === null || _b === void 0 ? void 0 : _b.sysPrefixPath;
            if (path && path.startsWith('/') && sysPrefixPath) {
                newApiSchema.url.path = sysPrefixPath + path;
            }
        }
    }
    return newApiSchemaMap;
};
export const createService = function createService(apiSchemaList, serviceConfig, dynamicServices) {
    var _a, _b;
    addConfigs(service);
    const fixServiceConfig = serviceConfig || {};
    fixServiceConfig.config = fixServiceConfig.config || {};
    Object.assign(fixServiceConfig.config, {
        httpCode: true,
        httpError: true,
        shortResponse: true,
    });
    {
        service.postConfig.set('postRequestError', {
            reject(response, params, requestInfo) {
                return __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c, _d, _e;
                    response.Code = response.code || response.status;
                    const status = 'error';
                    const err = response;
                    const { config } = requestInfo;
                    if (!response.response) {
                        throw response;
                    }
                    if ((_b = (_a = response.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.Data) {
                        overwriteErrorMsgFieldIfSpecified(response.response.data.Data, (_c = requestInfo === null || requestInfo === void 0 ? void 0 : requestInfo.config) === null || _c === void 0 ? void 0 : _c.errorMessage);
                    }
                    const HttpResponse = {
                        status: response.response.status + '',
                        body: JSON.stringify(response.response.data),
                        headers: response.response.headers,
                        cookies: formatCookie(document.cookie),
                    };
                    let event = Object.assign({ response: HttpResponse, requestInfo,
                        status }, HttpResponse);
                    if (typeof window.postRequest === 'function') {
                        yield window.postRequest(event);
                    }
                    // 开启handleError时，不抛出错误，返回response
                    if (config === null || config === void 0 ? void 0 : config.handleError) {
                        let body = ((_d = event === null || event === void 0 ? void 0 : event.response) === null || _d === void 0 ? void 0 : _d.body) || (event === null || event === void 0 ? void 0 : event.body);
                        try {
                            response.data = JSON.parse(body);
                        }
                        catch (error) {
                            // 解析不了则直接返回
                            throw err;
                        }
                        // 此时跳过shortResponse中的兼容操作
                        response.skipShortResponseCopy = true;
                        response.headers = ((_e = event === null || event === void 0 ? void 0 : event.response) === null || _e === void 0 ? void 0 : _e.headers) || (event === null || event === void 0 ? void 0 : event.headers);
                        return response;
                    }
                    throw err;
                });
            },
        });
        fixServiceConfig.config = Object.assign(Object.assign({}, fixServiceConfig.config), { priority: Object.assign(Object.assign({}, (fixServiceConfig.config.priority ? fixServiceConfig.config.priority : {})), { postRequestError: 10 }) });
        fixServiceConfig.config.postRequestError = true;
    }
    serviceConfig = fixServiceConfig;
    const newApiSchemaMap = adjustPathWithSysPrefixPath(apiSchemaList);
    let logicsInstance = service.generator(newApiSchemaMap, dynamicServices, serviceConfig);
    let mockInstance = {};
    if (window.appInfo.isPreviewFe) {
        if ((_a = window === null || window === void 0 ? void 0 : window.allMockData) === null || _a === void 0 ? void 0 : _a.mock) {
            JSON.parse((_b = window === null || window === void 0 ? void 0 : window.allMockData) === null || _b === void 0 ? void 0 : _b.mock).map((v) => {
                createMockServiceByData(v.name, getData(v.mockData), mockInstance);
            });
            createMockServiceByData('GetUser', {}, mockInstance);
            createMockServiceByData('GetUserResources', {}, mockInstance);
            Object.keys(logicsInstance).map((apiName) => !mockInstance[apiName] && (mockInstance[apiName] = logicsInstance[apiName]));
        }
    }
    else {
        mockInstance = logicsInstance;
    }
    return mockInstance;
};
export const createLogicService = function createLogicService(apiSchemaList, serviceConfig, dynamicServices) {
    var _a, _b, _c;
    const fixServiceConfig = serviceConfig || {};
    fixServiceConfig.config = fixServiceConfig.config || {};
    Object.assign(fixServiceConfig.config, {
        shortResponse: true,
        concept: 'Logic',
    });
    serviceConfig = fixServiceConfig;
    const newApiSchemaMap = adjustPathWithSysPrefixPath(apiSchemaList);
    if (window.preRequest) {
        service.preConfig.set('preRequest', {
            resolve(requestInfo, preData) {
                return __awaiter(this, void 0, void 0, function* () {
                    const HttpRequest = {
                        requestURI: requestInfo.url.path,
                        remoteIp: '',
                        requestMethod: requestInfo.url.method,
                        body: JSON.stringify(requestInfo.url.body),
                        headers: requestInfo.url.headers,
                        querys: JSON.stringify(requestInfo.url.query),
                        cookies: formatCookie(document.cookie),
                        requestInfo,
                    };
                    let data = preData;
                    if (typeof window.preRequest === 'function') {
                        data = yield window.preRequest(HttpRequest, preData);
                    }
                    return data || preData;
                });
            },
        });
        serviceConfig.config.preRequest = true;
    }
    if (window.postRequest) {
        service.postConfig.set('postRequest', {
            resolve(response, params, requestInfo) {
                return __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c;
                    if (!response) {
                        return Promise.reject();
                    }
                    if (((_a = requestInfo === null || requestInfo === void 0 ? void 0 : requestInfo.config) === null || _a === void 0 ? void 0 : _a.serviceType) === 'sse') {
                        return response;
                    }
                    const status = 'success';
                    const { config } = requestInfo;
                    const serviceType = config === null || config === void 0 ? void 0 : config.serviceType;
                    if (serviceType && serviceType === 'external') {
                        return response;
                    }
                    const HttpResponse = {
                        status: response.status + '',
                        body: JSON.stringify(response.data),
                        headers: response.headers,
                        cookies: formatCookie(document.cookie),
                    };
                    let event = Object.assign({ response: HttpResponse, requestInfo,
                        status }, HttpResponse);
                    if (typeof window.postRequest === 'function') {
                        yield window.postRequest(event);
                    }
                    let body = ((_b = event === null || event === void 0 ? void 0 : event.response) === null || _b === void 0 ? void 0 : _b.body) || (event === null || event === void 0 ? void 0 : event.body);
                    try {
                        response.data = JSON.parse(body);
                    }
                    catch (error) {
                        response.data = body;
                    }
                    response.headers = ((_c = event === null || event === void 0 ? void 0 : event.response) === null || _c === void 0 ? void 0 : _c.headers) || (event === null || event === void 0 ? void 0 : event.headers);
                    return response;
                });
            },
        });
        service.postConfig.set('postRequestError', {
            reject(response, params, requestInfo) {
                return __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c, _d, _e, _f, _g;
                    if (((_a = requestInfo === null || requestInfo === void 0 ? void 0 : requestInfo.config) === null || _a === void 0 ? void 0 : _a.serviceType) === 'sse') {
                        throw Error('远端调用异常');
                    }
                    response.Code = response.code || response.status;
                    const status = 'error';
                    const err = response;
                    const { config } = requestInfo;
                    if (err === 'expired request') {
                        throw err;
                    }
                    if (!err.response) {
                        if (!config.noErrorTip) {
                            // instance.show('系统错误，请查看日志！');
                            Config.toast.error('系统错误，请查看日志！');
                            // 得抛错，否则会走成功回调，然后shortResponse会报错
                            throw err;
                        }
                    }
                    if ((_b = window.LcapMicro) === null || _b === void 0 ? void 0 : _b.loginFn) {
                        if (err.Code === 401 && err.Message === 'token.is.invalid') {
                            window.LcapMicro.loginFn();
                            return;
                        }
                        if (err.Code === 'InvalidToken' && err.Message === 'Token is invalid') {
                            window.LcapMicro.loginFn();
                            return;
                        }
                    }
                    if (err.Code === 501 && err.Message === 'abort') {
                        throw Error('程序中止');
                    }
                    if (!response.response) {
                        throw response;
                    }
                    if ((_d = (_c = response.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.Data) {
                        overwriteErrorMsgFieldIfSpecified(response.response.data.Data, (_e = requestInfo === null || requestInfo === void 0 ? void 0 : requestInfo.config) === null || _e === void 0 ? void 0 : _e.errorMessage);
                    }
                    const HttpResponse = {
                        status: response.response.status + '',
                        body: JSON.stringify(response.response.data),
                        headers: response.response.headers,
                        cookies: formatCookie(document.cookie),
                    };
                    let event = Object.assign({ response: HttpResponse, requestInfo,
                        status }, HttpResponse);
                    if (typeof window.postRequest === 'function') {
                        yield window.postRequest(event);
                    }
                    // 开启handleError时，不抛出错误，返回response
                    if (config === null || config === void 0 ? void 0 : config.handleError) {
                        let body = ((_f = event === null || event === void 0 ? void 0 : event.response) === null || _f === void 0 ? void 0 : _f.body) || (event === null || event === void 0 ? void 0 : event.body);
                        try {
                            response.data = JSON.parse(body);
                        }
                        catch (error) {
                            // 解析不了则直接返回
                            throw err;
                        }
                        response.headers = ((_g = event === null || event === void 0 ? void 0 : event.response) === null || _g === void 0 ? void 0 : _g.headers) || (event === null || event === void 0 ? void 0 : event.headers);
                        return response;
                    }
                    throw err;
                });
            },
        });
        serviceConfig.config = Object.assign(Object.assign({}, serviceConfig.config), { priority: Object.assign(Object.assign({}, (serviceConfig.config.priority ? serviceConfig.config.priority : {})), { postRequest: 10, postRequestError: 10 }) });
        serviceConfig.config.postRequest = true;
        serviceConfig.config.postRequestError = true;
    }
    service.postConfig.set('lcapLocation', (response, params, requestInfo) => {
        var _a;
        const lcapLocation = (_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a['lcap-location'];
        if (lcapLocation) {
            location.href = lcapLocation;
        }
        return response;
    });
    serviceConfig.config = Object.assign(Object.assign({}, serviceConfig.config), { priority: Object.assign(Object.assign({}, (serviceConfig.config.priority ? serviceConfig.config.priority : {})), { lcapLocation: 1 }) });
    serviceConfig.config.lcapLocation = true;
    let logicsInstance = service.generator(newApiSchemaMap, dynamicServices, serviceConfig);
    let mockInstance = {};
    if (window.appInfo.isPreviewFe) {
        if ((_a = window === null || window === void 0 ? void 0 : window.allMockData) === null || _a === void 0 ? void 0 : _a.mock) {
            let mockApiList = JSON.parse((_b = window === null || window === void 0 ? void 0 : window.allMockData) === null || _b === void 0 ? void 0 : _b.mock).map((v) => v.name);
            JSON.parse((_c = window === null || window === void 0 ? void 0 : window.allMockData) === null || _c === void 0 ? void 0 : _c.mock).map((v) => {
                createMockServiceByData(v.name, getData(v.mockData), mockInstance);
            });
            Object.keys(logicsInstance).map((apiName) => !mockInstance[apiName] && (mockInstance[apiName] = logicsInstance[apiName]));
        }
    }
    else {
        mockInstance = logicsInstance;
    }
    return mockInstance;
};
